import React, { useState } from "react";
import styled from "styled-components";
import {
    AiOutlineDashboard,
    AiOutlineFileAdd,
    AiOutlineUnorderedList,
    AiOutlineBarChart,
    AiOutlineLogout,
    AiOutlineMenuFold,
    AiOutlineMenuUnfold,
    AiOutlineFilePdf
} from "react-icons/ai";
import LogoutPopup from "../../components/ui/LogoutPopup";

function SupervisorNavbar({ pageTitle, onNavigate }) {
    const [collapsed, setCollapsed] = useState(false);
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    const handleNavigation = (page) => {
        onNavigate(page);
    };

    // Show Logout Confirmation Popup
    const confirmLogout = () => {
        setShowLogoutPopup(true);
    };

    // Perform Logout if User Confirms
    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        setTimeout(() => {
            window.location.href = "/";
        }, 500);
    };

    return (
        <>
            <NavContainer className={collapsed ? "collapsed" : ""}>
                <div className="toggle-btn" onClick={toggleSidebar}>
                    {collapsed ? <AiOutlineMenuUnfold /> : <AiOutlineMenuFold />}
                </div>

                <div className="brand">
                    <h2>W. THOMAS & SONS</h2>
                    <p>Supervisor Dashboard</p>
                </div>

                <NavItems>
                    <NavItem
                        active={pageTitle === "Dashboard"}
                        onClick={() => handleNavigation("Dashboard")}
                    >
                        <AiOutlineDashboard />
                        <span>Dashboard</span>
                    </NavItem>
                    <NavItem
                        active={pageTitle === "DailyLog"}
                        onClick={() => handleNavigation("DailyLog")}
                    >
                        <AiOutlineFileAdd />
                        <span>Add Daily Log</span>
                    </NavItem>
                    <NavItem
                        active={pageTitle === "ViewLogs"}
                        onClick={() => handleNavigation("ViewLogs")}
                    >
                        <AiOutlineUnorderedList />
                        <span>View Logs</span>
                    </NavItem>
                    <NavItem
                        active={pageTitle === "Reports"}
                        onClick={() => handleNavigation("Reports")}
                    >
                        <AiOutlineFilePdf />
                        <span>Reports</span>
                    </NavItem>
                </NavItems>

                <LogoutButton onClick={confirmLogout}>
                    <AiOutlineLogout />
                    <span>Logout</span>
                </LogoutButton>
            </NavContainer>

            {/* Logout Confirmation Popup */}
            {showLogoutPopup && (
                <LogoutPopup
                    message="Are you sure you want to log out?"
                    onConfirm={handleLogout}
                    onClose={() => setShowLogoutPopup(false)}
                />
            )}
        </>
    );
}

export default SupervisorNavbar;

const NavContainer = styled.div`
    background-color: #000;
    color: white;
    width: 240px;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    transition: all 0.3s ease;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    z-index: 2000;
    
    &.collapsed {
        width: 60px;
        
        .brand h2, .brand p, .nav-item span, .logout-btn span {
            display: none;
        }
        
        .nav-item, .logout-btn {
            justify-content: center;
            padding: 10px 0;
        }
    }
    
    .toggle-btn {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 20px;
        cursor: pointer;
        background: none;
        border: none;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .brand {
        padding: 1rem 0;
        text-align: center;
        margin-bottom: 2rem;
        
        h2 {
            font-size: 18px;
            margin: 0;
            font-weight: 600;
        }
        
        p {
            margin: 5px 0 0 0;
            font-size: 12px;
            opacity: 0.7;
        }
    }
`;

const NavItems = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

const NavItem = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 15px;
    margin-bottom: 5px;
    cursor: pointer;
    border-radius: 5px;
    transition: background 0.2s;
    background-color: ${props => props.active ? "rgba(255,255,255,0.1)" : "transparent"};
    
    &:hover {
        background-color: rgba(255,255,255,0.1);
    }
    
    svg {
        font-size: 20px;
        margin-right: 10px;
    }
    
    span {
        font-size: 14px;
    }
`;

const LogoutButton = styled.div`
    display: flex;
    align-items: center;
    padding: 15px 15px;
    margin-top: auto;
    cursor: pointer;
    border-radius: 5px;
    transition: background 0.2s;
    color: #ff6b6b;
    
    &:hover {
        background-color: rgba(255,0,0,0.1);
    }
    
    svg {
        font-size: 20px;
        margin-right: 10px;
    }
    
    span {
        font-size: 14px;
    }
`;